import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table-cell--bold table-cell--before-after" }
const _hoisted_2 = { class: "table-cell--bold" }

import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import { useTransactionSummaryCalclation } from '@/InventoryControlModule/composables/useTransactionSummaryCalclation';
import { InventoryTableViewModel } from '@/InventoryControlModule/pages/inventoryTableViewModel';
import { IInventoryOrder } from '@/InventoryControlModule/domains/entities/InventoryOrder';
import { IBeforeAfterValue } from '@/InventoryControlModule/domains/entities/MonthlyData';
import { computed } from 'vue';
import { SUMMARY_ROW_BLANK_HEADER_KEYS, BEFORE_AFTER_KEYS } from '../../constants/';

/**
 * TransactionSummaryColumn コンポーネントのプロパティ
 */
interface Props {
  /** 対象の月 (相対月) */
  month: number;
  /** 月次データ */
  data: any;
  /** 表示対象のヘッダーリスト */
  headerList: string[];
  /** インベントリViewModel */
  inventoryVm: InventoryTableViewModel;
  /** 月次エンドヘッダー */
  monthlyEndHeader: string;
  /** 開いているページ情報 */
  isOrderMode?: boolean;
  /** 発注編集データ（発注モード時のみ） */
  orderEditData?: IInventoryOrder;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionSummaryColumn',
  props: {
    month: {},
    data: {},
    headerList: {},
    inventoryVm: {},
    monthlyEndHeader: {},
    isOrderMode: { type: Boolean, default: false },
    orderEditData: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props;

const { getTransactionData, getExpectedEndInventoryBeforeAfter, getTurnOverBeforeAfter } = useTransactionSummaryCalclation();

/**
 * 発注前後の値を取得する
 * @param key - トランザクションキー
 */
const getBeforeAfterValue = (key: string): IBeforeAfterValue | null => {
  if (!props.isOrderMode) return null;
  if (key === 'expectedEndInventory') {
    return getExpectedEndInventoryBeforeAfter(props.data, props.month, props.orderEditData);
  }
  if (key === 'turnOver') {
    return getTurnOverBeforeAfter(props.data, props.month, props.orderEditData);
  }
  return null;
};

const transactionSummaryDataList = computed(() => {
  return props.inventoryVm
    .getMonthlyTransactionHeaderKeys(props.month, props.isOrderMode)
    .map((key) => {
      if (!props.headerList.includes(`transaction-${props.month}-${key}`)) return null;
      const amount = getTransactionData(props.data, key, props.month, props.isOrderMode, props.orderEditData);
      const beforeAfter = getBeforeAfterValue(key);
      return {
        key,
        amount,
        isNegative: amount < 0,
        beforeAfter,
        showBeforeAfter: props.isOrderMode && beforeAfter?.hasChange && (BEFORE_AFTER_KEYS as readonly string[]).includes(key),
      };
    })
    .filter((data) => data !== null);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactionSummaryDataList.value, (transactionSummaryData) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: transactionSummaryData.key
    }, [
      ((_unref(SUMMARY_ROW_BLANK_HEADER_KEYS) as readonly string[]).includes(transactionSummaryData.key))
        ? (_openBlock(), _createBlock(EzCell, {
            key: 0,
            "is-number": "",
            "has-right-border": transactionSummaryData.key === _ctx.monthlyEndHeader,
            class: "table-cell table-cell--number table-cell--bold table-cell--totalization"
          }, null, 8, ["has-right-border"]))
        : (transactionSummaryData.showBeforeAfter && transactionSummaryData.beforeAfter)
          ? (_openBlock(), _createBlock(EzCell, {
              key: 1,
              "is-number": "",
              "has-right-border": transactionSummaryData.key === _ctx.monthlyEndHeader,
              class: "table-cell table-cell--number table-cell--bold table-cell--totalization"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'table-cell--negative': transactionSummaryData.beforeAfter.before < 0 })
                  }, _toDisplayString(transactionSummaryData.beforeAfter.before.roundToDecimal(2).addComma()), 3),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "table-cell--arrow" }, "→", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'table-cell--negative': transactionSummaryData.beforeAfter.after < 0 })
                  }, _toDisplayString(transactionSummaryData.beforeAfter.after.roundToDecimal(2).addComma()), 3)
                ])
              ], undefined, true),
              _: 2
            }, 1032, ["has-right-border"]))
          : (_openBlock(), _createBlock(EzCell, {
              key: 2,
              "is-number": "",
              "is-negative": transactionSummaryData.isNegative,
              "has-right-border": transactionSummaryData.key === _ctx.monthlyEndHeader,
              class: "table-cell table-cell--number table-cell--bold table-cell--totalization"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(transactionSummaryData.amount.roundToDecimal(2).addComma()), 1)
              ], undefined, true),
              _: 2
            }, 1032, ["is-negative", "has-right-border"]))
    ], 64))
  }), 128))
}
}

})